<template>
  <div class="aboutUser">
    <Input
      v-for="el in allInfoFromUser"
      :key="el.id"
      :type="el.type"
      :name="el.name"
      :label="$t(el.label)"
      :disabled="disabledInput(el.name)"
      :validation="el.validation"
      :validationMessages="{
        required: $t('validation.required')
      }"
      :data-testid="el.dataTestId"
    />
    <div class="aboutUser__info" v-if="isPharmacyId">
      <div class="aboutUser__info__pin">
        <Dropdown
          class="aboutUser__info-dropdown"
          :label="$t('role')"
          :selectedOption="userRoleDropdown.selectedOption"
          :options="userRoleDropdown.options"
          @selectOption="selectUser"
          data-testid="dropdownUserRole"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

import { allInfoFromUser } from '@/constants';
import { Option } from '@/types';

@Options({
  name: 'AboutUser',
  emits: ['selectUserRole'],
  props: ['userRoleDropdown'],
  data() {
    return {
      allInfoFromUser
    };
  },
  computed: {
    ...mapState('users', ['user']),
    isPharmacyId() {
      if (!this.user.pharmacyId) {
        return '';
      } else {
        return this.user.pharmacyId;
      }
    }
  },
  methods: {
    selectUser(option: Option) {
      this.$emit('selectUserRole', option);
    },
    disabledInput(name: string) {
      if (name === 'email') {
        return true;
      } else {
        return false;
      }
    }
  }
})
export default class AboutUserComponent extends Vue {}
</script>

<style lang="scss">
.aboutUser {
  margin-top: 32px;
  .input {
    width: 377px;
    margin-bottom: 32px;
  }
  .aboutUser__info {
    .aboutUser__info__pin {
      display: flex;
      flex-direction: column;
      margin-bottom: 32px;
      .aboutUser__info-dropdown {
        width: 377px;
        height: 48px;
        margin-bottom: 32px;
        .dropdown {
          height: 46px;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
